import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    /** 获取提醒信息列表 **/
    GET_SCHEDULE_CHILD_TYPE_LIST(data) {
        controller='Schedule';
        action='GetSheduleChildList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取提醒信息列表 **/
    GET_SCHEDULE_TYPE_LIST(data) {
        controller='Schedule';
        action='GetScheduleTypeList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 新增提醒类型信息 **/
    ADD_SCHDULE_TYPE(data) {
        controller='Schedule';
        action='AddScheduleType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑提醒类型信息 **/
    EDIT_SCHDULE_TYPE(data) {
        controller='Schedule';
        action='EditScheduleType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除提醒类型信息 **/
    DEL_SCHEDULE_TYPE(data) {
        controller='Schedule';
        action='DelScheduleType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 获取日程信息 **/
    GET_PET_SCHEDULE_LIST(data) {
        controller='Schedule';
        action='GetScheduleList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },


    /** 新增日程提醒 **/
    ADD_SHEDULE(data) {
        controller='Schedule';
        action='AddPetSchedule';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 编辑日程提醒 **/
    EDIT_SHEDULE(data) {
        controller='Schedule';
        action='EditPetSchedule';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 删除日程提醒 **/
    DEL_SCHEDULE(data) {
        controller='Schedule';
        action='DelPetSchedule';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 完成提醒 **/
    FINISH_SCHEDULE(data) {
        controller='Schedule';
        action='FinishPetSchedule';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取提醒信息 **/
    GET_SCHEDULE_INFOS(data) {
        controller='Schedule';
        action='GetPetScheduleInfos';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取全部宠物信息列表 **/
    GET_PET_LIST(data) {
        controller='Schedule';
        action='GetAllPetList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data }); 
    },

}